import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';

const propTypes = {
	data: PropTypes.object,
	toggleRankPopup: PropTypes.func,
	ranksList: PropTypes.object
};

const ModalBody = props => {
	const { is_new_max_rank } = props.data;
	const userRank = props.ranksList.find( rk => rk.id === props.data.rank_id);
	return (
		<div className={cn({
			'notification__body': true,
			'centered': !is_new_max_rank
		})}>
			<div className="notification__description font-proxima-nova-regular">
				<div>
					Поздравляем! Вы достигли статуса "{userRank.name.replace('_', ' ')}".
					{is_new_max_rank && <span>Теперь вы можете забрать у вашего менеджера подарок! </span>}
					Остальные фишки этого статуса вы можете посмотреть
					<span
						className="hide__link font-proxima-nova-bold"
						onClick={() => props.toggleRankPopup(false)}
					>
						тут
					</span>!
				</div>
				<button
					className="button font-proxima-nova-semibold close"
					onClick={() => props.toggleRankPopup(false)}
				>
					ОК
				</button>
			</div>
		</div>
	);
};

ModalBody.propTypes = propTypes;

export default ModalBody;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/ranks/components/notification-modal.js